import apiFetch from '../apiFetch'

export default function (token, documentId, documentTypeUseId, dossierId) {
  return apiFetch({ endPoint: `Sign/SignTypeLocales?documentId=${documentId}&documentTypeUseId=${documentTypeUseId}&dossierId=${dossierId}`, method: 'GET', token: token })
}
